import { paramsSerializer } from 'API/paramsSerializer';
import { DateTime } from 'luxon';
import { IActivityQuery } from 'types/order/activities/IActivityQuery';
import { IActivityResponse } from 'types/order/activities/IActivityResponse';
import { convertFromIQueryResponseToIPageData } from 'types/rest/IPageData';
import { baseUrlService } from '../../../ui-toolkit/rest/BaseUrlService';
import { IQueryResponse } from '../../../types/rest/IQueryResponse';
import { APIFactory } from '../../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../../ui-toolkit/rest/axiosErrorHandler';

export const getActivitiesAsync = ({ orderId, occurredAtEnd, occurredAtStart, ...rest }: IActivityQuery) =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IQueryResponse<IActivityResponse>>(`/timber/api/internal/orders/${orderId}/activities`, {
      params: {
        ...rest,
        occurredAtEnd: occurredAtEnd && DateTime.fromISO(occurredAtEnd).toISO(),
        occurredAtStart: occurredAtStart && DateTime.fromISO(occurredAtStart).toISO(),
      },
      paramsSerializer,
    })
    .then((t) => convertFromIQueryResponseToIPageData(t.data, (t) => t))
    .catch(axiosErrorHandler);
